import { get } from "axios";
import { getRequest } from "../../utils/helpers/common/http-methods";

export const Dashboard_APIS = {
  getDashboard: () => getRequest("/dashboard"),

  getPopularStats: (params: any) => getRequest("/dashboard/popular-stats", params ),
  getNumberOfAttendees: (params: any) => getRequest("/dashboard/number-of-attendees", params ),
  getNumberOfEventsInLocation: (params: any) => getRequest("/dashboard/number-of-events-in-location", params ),
  getNumberOfBusinesses: (params: any) => getRequest("/dashboard/number-of-businesses", params ),
  getNumberOfBusinessesInIndustry: (params: any) => getRequest("/dashboard/number-of-businesses-in-industry", params ),
  getNumberOfBusinessesInEachMembership: (params: any) => getRequest("/dashboard/number-of-businesses-in-each-membership", params ),
  getCancellationRateByHost: (params: any) => getRequest("/dashboard/cancellation-rate-by-host", params ),
  getAmbassadorInEachEngagementLevel: (params: any) => getRequest("/dashboard/ambassador-in-each-engagement-level", params ),
  getAmbassadorInEachTier: (params: any) => getRequest("/dashboard/ambassador-in-each-tier", params ),
  getNumberOfAmbassador: (params: any) => getRequest("/dashboard/number-of-ambassador", params ),







};
